import * as XLSX from 'xlsx';
import { formatCategoryName } from './categoryFormatter';

export const generateDeclinedServicesReport = (declinedItemsWithContext, filters = null) => {
  const reportData = [];

  declinedItemsWithContext.forEach((item) => {
    reportData.push({
      'Service Order Number': item.repairOrderId ? String(item.repairOrderId) : 'N/A',
      'Shop': item.dealerShipName || 'N/A',
      'Customer Name': item.customerName || 'N/A',
      'Vehicle Information': `${item.year || ''} ${item.make || ''} ${item.model || ''}`.trim() || 'N/A',
      'Declined Service': item.serviceName || 'N/A',
      'Category': formatCategoryName(item.serviceCategory),
      'Price': item.price ? `$${item.price.toFixed(2)}` : 'N/A',
      'Date': item.createdDate ? new Date(item.createdDate).toLocaleDateString() : 'N/A',
    });
  });

  const ws = XLSX.utils.json_to_sheet(reportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Declined Services');

  // Set column widths
  ws['!cols'] = [
    { wch: 20 }, // Service Order Number
    { wch: 20 }, // Shop
    { wch: 20 }, // Customer Name
    { wch: 30 }, // Vehicle Information
    { wch: 25 }, // Declined Service
    { wch: 15 }, // Category
    { wch: 12 }, // Price
    { wch: 15 }, // Date
  ];

  const filename = `Declined_Services_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(wb, filename);
};

export const generateDeclinedItemsReport = (declinedItems, repairOrderId, orderDetails = {}) => {
  const reportData = [];

  declinedItems.forEach((item) => {
    reportData.push({
      'Service Order Number': repairOrderId ? String(repairOrderId) : 'N/A',
      'Shop': orderDetails.shop || 'N/A',
      'Customer Name': orderDetails.customerName || 'N/A',
      'Vehicle Information': orderDetails.vehicle || 'N/A',
      'Declined Service': item.serviceName || 'N/A',
      'Category': formatCategoryName(item.serviceCategory),
      'Price': item.price ? `$${item.price.toFixed(2)}` : 'N/A',
      'Date': orderDetails.date || 'N/A',
    });
  });

  const ws = XLSX.utils.json_to_sheet(reportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Declined Items');

  // Set column widths
  ws['!cols'] = [
    { wch: 20 }, // Service Order Number
    { wch: 20 }, // Shop
    { wch: 20 }, // Customer Name
    { wch: 30 }, // Vehicle Information
    { wch: 25 }, // Declined Service
    { wch: 15 }, // Category
    { wch: 12 }, // Price
    { wch: 15 }, // Date
  ];

  const filename = `Declined_Items_Report_${repairOrderId}_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(wb, filename);
};
